import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import { getContactsList, submitContactsListExcel } from "../../api/Api";
import { permittedIDs } from "../../components/TopBarComponent/Topbar";

export const ContactsContext = createContext({});

export const ContactsContextProvider = ({ children }) => {
  const addContactsPermission = permittedIDs && permittedIDs.includes(11);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [contactsFile, setContactsFile] = useState();
  const [contactsFileRequired, setContactsFileRequired] = useState(false);
  const [contactsFilelabel, setContactsFilelabel] = useState(
    "Select an Excel File"
  );
  const [contactsList, setContactsList] = useState([
    { id: 0, Category: "", EmployeeName: "", ContactNo: "" },
  ]);
  const [contactsShowAlert, setContactsShowAlert] = useState(false);
  const [contactsAlertMessage, setContactsAlertMessage] = useState();
  const [statusCode, setStatusCode] = useState();
  const [invalidSession, setInvalidSession] = useState();
  const [spinnerStatus ,setSpinnerStatus] = useState(false)
  const goBack = () => {
    navigate(-1);
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  const contactsErrorAlertSubmit = () => {
    invalidSession === 401 ? logout() : setContactsShowAlert(false);
  };

  const callContactsList = async () => {
    setSpinnerStatus(true)
    try {
      const getContactsData = await getContactsList();
      if (getContactsData?.data?.status === 200) {
        setContactsList(getContactsData?.data?.data?.contact);
        setSpinnerStatus(false)
      }
    } catch (error) {
      setSpinnerStatus(false)
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400 ||
        error.response.data.status === 405
      ) {
        setInvalidSession(error.response.data.status);
        setContactsShowAlert(true);
        setContactsAlertMessage(error.response.data.message);
      } else {
        setContactsShowAlert(true);
        setContactsAlertMessage("Something went wrong");
      }
    }
  };

  const appendContactsListExcelFile = () => {
    let formData = new FormData();
    formData.append("contactList", contactsFile);
    return formData;
  };

  const submitContactsList = async () => {
    try {
      const submitContactsData = await submitContactsListExcel(
        appendContactsListExcelFile()
      );
      if (submitContactsData.data.status === 200) {
        setShow(false);
        callContactsList();
        setContactsFile("");
        setContactsFilelabel("Select an Excel File");
        setContactsShowAlert(true);
        setContactsAlertMessage(submitContactsData.data.message);
      }
    } catch (error) {
      setShow(false);
      setStatusCode(error.response.data.status);
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400 ||
        error.response.data.status === 405 ||
        error.response.data.status === 403
      ) {
        setInvalidSession(error.response.data.status);
        setContactsShowAlert(true);
        setContactsAlertMessage(error.response.data.message);
        setContactsFile("");
        setContactsFilelabel("Select an Excel File");
      } else {
        setContactsShowAlert(true);
        setContactsAlertMessage("Incorrect File Structure. Please Try Again.");
        setContactsFile("");
        setContactsFilelabel("Select an Excel File");
      }
    }
  };

  const handleAlertSubmit = () => {
    callContactsList();
    setContactsShowAlert(false);
  };
  useEffect(() => {
    callContactsList();
  }, []);

  const providerValue = {
    goBack,
    show,
    setShow,
    contactsFile,
    setContactsFile,
    contactsFileRequired,
    setContactsFileRequired,
    contactsFilelabel,
    setContactsFilelabel,
    contactsList,
    contactsShowAlert,
    setContactsShowAlert,
    contactsAlertMessage,
    contactsErrorAlertSubmit,
    submitContactsList,
    addContactsPermission,
    handleAlertSubmit,
    logout,
    statusCode,
    spinnerStatus ,setSpinnerStatus
  };

  return (
    <ContactsContext.Provider value={providerValue}>
      {children}
    </ContactsContext.Provider>
  );
};
